export default __webpack_public_path__ + "static/media/screwdriver.e8273c64.png";